import { render } from "./PunchOutGeolocation.vue?vue&type=template&id=beb6a2d6"
import script from "./PunchOutGeolocation.vue?vue&type=script&lang=js"
export * from "./PunchOutGeolocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__